const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TrustBadges = ({ className = '', compact = false }) => (
  <div className={`flex flex-col gap-2 ${className}`} data-testid="trust-badges">
    <div className="flex items-center justify-center gap-3">
      <img
        src={`${API}/static/brand/trust_shipping.png?v=5`}
        alt="Shipped via Blue Dart — DHL Group Express"
        className={`${compact ? 'h-6' : 'h-[26px] md:h-7'} w-auto object-contain select-none`}
        draggable={false}
      />
      <img
        src={`${API}/static/brand/trust_razorpay.png?v=5`}
        alt="100% secure payments powered by Razorpay"
        className={`${compact ? 'h-6' : 'h-[26px] md:h-7'} w-auto object-contain select-none`}
        draggable={false}
      />
      <img
        src={`${API}/static/brand/trust_ssl.png?v=2`}
        alt="SSL secured — 256-bit encryption"
        className={`${compact ? 'h-6' : 'h-[26px] md:h-7'} w-auto object-contain select-none`}
        draggable={false}
      />
    </div>
    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#A1A1AA] text-center leading-relaxed">
      <p>Express shipping by Blue Dart</p>
      <p>100% secure payments via Razorpay</p>
      <p>SSL secured &middot; 256-bit encryption</p>
    </div>
  </div>
);
